import { render, staticRenderFns } from "./DateRangeField.vue?vue&type=template&id=2481b96c&scoped=true&"
import script from "./DateRangeField.vue?vue&type=script&lang=js&"
export * from "./DateRangeField.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeField.vue?vue&type=style&index=0&id=2481b96c&prod&scoped=true&lang=css&"
import style1 from "./DateRangeField.vue?vue&type=style&index=1&id=2481b96c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2481b96c",
  null
  
)

export default component.exports